var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMarkerIconGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2536 29.1344C13.4969 26.6309 6.36035 19.6157 6.36035 14.0873C6.36035 7.23571 10.7451 2.66797 17.3223 2.66797C23.8995 2.66797 28.2843 7.23571 28.2843 14.0873C28.2843 19.6157 21.1477 26.6309 18.3911 29.1344C17.7789 29.6904 16.8657 29.6904 16.2536 29.1344ZM17.3223 17.3346C19.5926 17.3346 21.433 15.5437 21.433 13.3346C21.433 11.1254 19.5926 9.33457 17.3223 9.33457C15.052 9.33457 13.2116 11.1254 13.2116 13.3346C13.2116 15.5437 15.052 17.3346 17.3223 17.3346Z",
    fill: "#6C757D"
  })));
}

export default SvgMarkerIconGray;